import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class UnitRequest {
    @ApiProperty()
    unitId?: number;
    @ApiProperty()
    role?: EmployeeRolesEnum;
    @ApiProperty()
    companyId?: number;
    @ApiProperty()
    destinationId?:number
    @ApiProperty()
    fromDate: any;
    @ApiProperty()
    toDate: any;
    @ApiProperty()
    financialYear?: string;
        @ApiProperty()
    containerStatus?: string;
    constructor(unitId: number, role?: EmployeeRolesEnum,companyId?: number,destinationId?:number,fromDate?: any, toDate?: any,financialYear?: string,containerStatus?: string) {   
        this.unitId = unitId;
        this.role = role;
        this.companyId = companyId;
        this.destinationId = destinationId;
        this.fromDate = fromDate;   
        this.toDate = toDate; 
        this.financialYear = financialYear;  
        this.containerStatus = containerStatus;
    }
}